import React, { useState } from 'react';
import {
  Space,
  Button,
  Conditional,
  ModalContent,
  ModalHeader,
  Cross,
} from '@cashfree-intl/coherent';
import { SubStepDescription } from 'containers/CheckoutJourney/screens/styled';
import { StyledScreenModal } from 'containers/ProductTour/component/Shopify/SecondDay/styled';
import CheckoutOne from 'containers/CheckoutOneCustomisation';
import { INTEGRATION_STATUS } from 'containers/CheckoutJourney/util/constant';
import { sendAnalyticsData } from 'containers/ProductTour/helper';
import { SubstepComponentProps } from 'containers/CheckoutJourney/types';

const CustomiseCheckout = ({
  substep,
  updateStatus,
}: SubstepComponentProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const onCloseCustomisation = () => {
    updateStatus(substep.id, INTEGRATION_STATUS.COMPLETED);
    setModalOpen(false);
    sendAnalyticsData('customiseCheckoutButtonClicked');
  };

  const onOpenCustomisation = () => {
    setModalOpen(true);
  };

  const onClickWilldoLater = () => {
    updateStatus(substep.id, INTEGRATION_STATUS.PENDING);
  };

  return (
    <Space gap={2.5} direction="column" className="mt-2">
      <SubStepDescription color="bodyLight">
        {substep.description}
      </SubStepDescription>
      <Space gap={1}>
        <Button primary onClick={onOpenCustomisation}>
          Customise Checkout
        </Button>
        <Button link onClick={onClickWilldoLater}>
          I&apos;ll do this later
        </Button>
      </Space>
      <Conditional if={modalOpen}>
        <StyledScreenModal open={modalOpen} onClose={onCloseCustomisation}>
          <ModalHeader>
            Checkout Customisations <Cross onClick={onCloseCustomisation} />
          </ModalHeader>
          <ModalContent className="p-3">
            {/* @ts-ignore */}
            <CheckoutOne disableBanner />
          </ModalContent>
        </StyledScreenModal>
      </Conditional>
    </Space>
  );
};

export { CustomiseCheckout };
